

export const CustomerData = [
    {
        customername: 'Vikrama Vyas',
        date: '20th June, 2024',
        customerlocation: 'Akurdi, Pune',
        iscurrent: false,
    },
    {
        customername: 'Kavya Gandhi',
        date: '20th June, 2024',
        customerlocation: 'Viman Nagar, Pune',
        iscurrent: false,
    },
    {
        customername: 'Vanraj Joshi',
        date: '20th June, 2024',
        customerlocation: 'Kharadi, Pune',
        iscurrent: true,
    },
    {
        customername: 'Preeti Suri',
        date: '20th June, 2024',
        customerlocation: 'Viman Nagar, Pune',
        iscurrent: true,
    },
];

export default CustomerData;